import { Document, Page, Text, View, StyleSheet, Image, Font, Link } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NotoSansRegular from '../fonts/NotoSans-Regular.ttf';
import NotoArabicSans from '../fonts/NotoSansArabic-Regular.ttf';
import ArialMS from '../fonts/Arial-Unicode-MS-Regular.ttf';

Font.registerEmojiSource({
    format: 'png',
    url: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/",
});

Font.register({ family: "NotoSans", src: NotoSansRegular });
Font.register({ family: "NotoSansArabic", src: NotoArabicSans });
Font.register({ family: "ArialMS", src: ArialMS });

const styles = StyleSheet.create({
    page: {
        paddingHorizontal: 20,
        paddingVertical: 30
    },
    userMessage: {
        marginBottom: 10,
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        display: 'flex'
    },
    botMessage: {
        marginBottom: 10,
        alignItems: 'flex-start',
        display: 'flex',
        justifyContent: 'flex-start',
    },
    messageContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    botText: {
        fontSize: 11,
        // backgroundColor: '#f5f5f5',
        // paddingHorizontal: 15,
        paddingVertical: 5,
        borderRadius: 10,
        borderBottomLeftRadius: 0,
        maxWidth: '95%',
        lineHeight: 1.4
    },
    userText: {
        fontSize: 11,
        // backgroundColor: '#912d2a',
        // paddingHorizontal: 15,
        paddingVertical: 5,
        borderRadius: 10,
        borderBottomRightRadius: 0,
        maxWidth: '85%',
        lineHeight: 1.2
    },
    icon: {
        width: 12,
        height: 12,
        marginLeft: 10,
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 20
    },
    logo: {
        width: '100pt',
        height: '100pt',
        objectFit: 'contain',
    },
    moreInfoContainer: {
        // marginTop: 20,
        paddingHorizontal: 40,
        paddingVertical: 10,
        // borderColor: '#912d2a',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 5,
        minWidth: '70%',
        maxWidth: '70%',
        margin: 'auto',
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    moreInfoText: {
        fontSize: 9,
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: 5
    },
    siteLink: {
        fontSize: 11,
        textAlign: 'center',
        fontWeight: 'heavy',
        textDecoration: 'underline',
        color: 'black'
    },
    name: {
        fontSize: 11,
        lineHeight: 1.2,
        fontWeight: 'heavy'
    },
    botName: {
        fontSize: 11,
        lineHeight: 1.2,
        textAlign: 'right',
        fontWeight: 'heavy'
    },
    date: {
        fontSize: 10,
        textAlign: 'center',
        marginBottom: 30,
    },
    chatIdContainer: {
        marginBottom: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chatIdText: {
        fontSize: 10,
        textAlign: 'center',
    }
})

const ConversationPDF = ({ messages, bot, botId, voiceMode, publicMode, dateInfo, primary, domain, chatId }) => {

    const { t, i18n } = useTranslation();

    const url = `http://${domain}/${publicMode ? `?bot=${botId}&voiceMode=${voiceMode}` : domain.includes('creator') ? `agents/${bot.slug}/?id=${bot.id}` : ''}`;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.imageContainer}>
                    <Image src={bot.image} style={styles.logo} />
                </View>
                <View style={styles.chatIdContainer}>
                    <Text style={[styles.chatIdText, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>{t('Chat ID')}: {chatId}</Text>
                </View>
                <ChatMessage messages={messages} bot={bot} language={i18n.language} />
                <View style={[styles.moreInfoContainer, { borderColor: primary}]}>
                    <Text style={[styles.moreInfoText, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>{t('check out more info here:')}</Text>
                    <Link src={url} style={[styles.siteLink, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}><Text>{`https://${domain}`}</Text></Link>
                </View>
                <Text style={[styles.date, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' } ]}>{dateInfo}</Text>
            </Page>
        </Document>
    )
}


const ChatMessage = ({ messages, bot, language }) => {

    const { i18n } = useTranslation();

    const rows = messages.map((item, key) =>
        <View style={[item.role === 'assistant' ? styles.botMessage : styles.userMessage, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]} key={key}>
            <Text style={[item.role === 'assistant' ? styles.botName : styles.name, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>{item.role === 'assistant' ? bot?.name : "User"}:</Text>
            <Text style={[item.role === 'assistant' ? styles.botText : styles.userText, { fontFamily: i18n.language == 'ar' ? 'NotoSansArabic': 'NotoSans' }]}>
                {item.content}
            </Text>
        </View>
    );
    return (<>{rows}</>)
}

export default ConversationPDF;